<template>
  <div class="follow-page detail page-padding-top">
    <top-bar :title="i18n.t('followDetail.title')"  @back="back"></top-bar>
    <div class="follow-home" >

      <div class="user-list">
        <div class="list" >
          <div class="flex-center info">
            <div class="header">P</div>
            <div class="flex-1">
              <div class="name flex-center-start">
                <span>{{resetName(detailData.Name)}}</span>
                <img :src="levelObj[`url${1}`]" alt="">
              </div>
              <div class="email">
                {{resetEmail(detailData.Email)}}
              </div>
            </div>
          </div>
          <div class="flex-wrap user-statistics">
            <div class="box flex-column-center border border-right">
              <div class="label">{{$t('follow.label1')}}(USDT)</div>
              <div class="count green">{{detailData.TotalProfit.toFixed(2)}}</div>
            </div>
            <div class="box flex-column-center border">
              <div class="label">{{$t('follow.label2')}}</div>
              <div class="count ">{{detailData.TotalTrade}}</div>
            </div>
            <div class="box flex-column-center border-right">
              <div class="label">{{$t('follow.label3')}}</div>
              <div class="count ">77/100</div>
            </div>
            <div class="box flex-column-center">
              <div class="label">{{$t('follow.label4')}}(USDT)</div>
              <div class="count green">{{detailData.TotalProfit.toFixed(2)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="follow-user">

      <div class="history-list">
        <div class="top-tab">
          <Tabs
            v-model="orderIndex"
            :line-width="0"
            :line-height="0"
            color="#23262F"
            title-inactive-color="#85898F"
            title-active-color="#23262F"
          >
            <Tab v-for="(item, i) in tabList" :key="i" :title="item"></Tab>
          </Tabs>
        </div>
        <div class="list-box" v-if="orderIndex == 1 || orderIndex == 2">
          <div class="empty flex-column-center">
            <img :src="emptyUrl" alt="">
            <div class="desc">{{$t('common.empty')}}</div>
          </div>
        </div>

        <div class="list-box" v-if="orderIndex == 0">
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label15')}}</div>
            <div class="count">{{detailData.Type == 'contract' ? $t('followDetail.label17') : $t('followDetail.label16')}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label1')}}</div>
            <div class="count">{{detailData.TotalProfit}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label2')}}</div>
            <div class="count">{{detailData.Followers}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label3')}}</div>
            <div class="count">{{detailData.HistoryFollowers}}</div>
          </div>
          <div class="list-line border flex-center-between">
            <div class="label">{{$t('followDetail.label4')}}</div>
            <div class="count">{{detailData.FollowRatio}}%</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label5')}}</div>
            <div class="count">{{detailData.TotalTrade}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label6')}}</div>
            <div class="count">{{detailData.TotalProfitTrade}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label7')}}</div>
            <div class="count">{{detailData.TotalLossTrade}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label8')}}</div>
            <div class="count">{{detailData.TotalTradeDays}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label9')}}</div>
            <div class="count">{{detailData.Currency.ShortName}}</div>
          </div>
          <div class="list-line border flex-center-between">
            <div class="label">{{$t('followDetail.label10')}}</div>
            <div class="count">{{detailData.UpdatedAt}}</div>
          </div>
         
          <div class="list-line small">
            <div class="label">{{$t('followDetail.label11')}}</div>
            <div class="label">{{$t('followDetail.label12')}}</div>
          </div>

        </div>
        <div class="list-box" v-if="orderIndex == 3">
          <!-- <div class="query-btn flex-center-start">
            <Button class="btn" :class="userType == 1 ? 'active' : ''" @click="changeType(1)">{{$t('follow.btn2')}}</Button>
            <Button class="btn" :class="userType == 2 ? 'active' : ''" @click="changeType(2)">{{$t('follow.btn3')}}</Button>
          </div> -->

          <div class="user-list clear">
            <div class="list" v-for="(item, i) in followUserList" :key="i">
              <div class="user-info small flex-center-between">
                <div class="flex-center">
                  <div class="header">P</div>
                  <div class="name flex-center-start">
                    pa**ke@gmail.com
                  </div>
                </div>
              </div>
              <div class="mt-20 flex-center-between">
                <div class="label">{{$t('followDetail.label13')}}</div>
                <div class="label">{{$t('followDetail.label14')}}</div>
              </div>
              <div class="mt-5 flex-center-between">
                <div class="count" >{{item.count}}</div>
                <div class="count" :class="item.count < 0 ? 'red' : 'green'">{{item.count}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <Button class="bottom-btn" @click="toDetail">{{$t('followDetail.btn')}}</Button>
  </div>
</template>
<script>
import { Button, Tabs, Tab } from 'vant'
import { copyTradeList } from '@/api/trade'
import { resetName, resetEmail } from '@/utils/common'
import topBar from '@/components/topBar'
export default {
  name: 'home',
  components: {
    topBar,
    Button,
    Tabs,
    Tab
  },
  data() {
    return {
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      homeUrl: require('../../assets/imgs/follow-home.png'),
      homeUrl2: require('../../assets/imgs/follow-home2.png'),
      userUrl: require('../../assets/imgs/follow-user.png'),
      userUrl2: require('../../assets/imgs/follow-user2.png'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      menuUrl1: require('../../assets/imgs/icon-transfer3.png'),
      menuUrl2: require('../../assets/imgs/icon-debt.png'),
      emptyUrl: require('../../assets/imgs/order-empty.png'),
      levelObj: {
        url1: require('../../assets/imgs/level1.png'),
        url2: require('../../assets/imgs/level2.png'),
      },
      followUserList: [
        {
          count: 123.33
        }, 
        {
          count: 433.33
        }, 
        {
          count: -23.33
        }, 
      ],
      showMoney: false,
      detailData: {
        Currency: {},
        TotalProfit: 0,
        TotalTrade: 0
      },
      dataId: ''
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
    tabList() {
      return [`${this.$t('followDetail.tab1')}`, this.$t('followDetail.tab2'), this.$t('followDetail.tab3'), this.$t('followDetail.tab4')]
    }
  },
  mounted() {
    let index =  sessionStorage.getItem('followIndex')
    this.tabIndex = index || 1
    // let data = sessionStorage.getItem('copyTradeData')
    // if (data) {
    //   this.detailData = JSON.parse(data)
    // }
    this.dataId = this.$route.query.id
    this.init()
  },
  methods: {
    resetEmail,
    resetName,
    init() {
      let form = new FormData()
      form.append('ID', this.dataId)
      copyTradeList(form).then(res => {
        let list = res.data.Items
        let index = list.findIndex(v => {
          return v.ID == this.dataId
        })
        if (index > -1) {
          this.detailData = res.data.Items[index] || {}
        }
      })
    },
    changeTab(i) {
      this.tabIndex = i
      sessionStorage.setItem('followIndex', i)
    },
    back() {
      this.$router.go(-1)
      sessionStorage.setItem('followIndex', 1)
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    changeType(type) {
      this.userType = type
    },
    toDetail() {
      this.$router.push({
        name: 'tradeFollow'
      })
    },
  }
}
</script>